import * as Yup from "yup";
import checkout from "./form3";

const {
  formField3: {
    taxpayers,
    taxCode,

    supportData,
  },
} = checkout;

const validation3 = Yup.object().shape({
  [taxpayers.name]: Yup.string().required(taxpayers.errorMsg),
  [taxCode.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxCode.invalidMsg)
    .required(taxCode.errorMsg),

  [supportData.name]: Yup.string().required(supportData.errorMsg),
});

export default validation3;
